export { ResetSitecoreStyles } from "./ResetSitecoreStyles";

type FormatNumberOptions = {
  fixedDecimal?: boolean;
};

export function formatNumber(
  value: number | bigint | null,
  options?: FormatNumberOptions,
): string {
  const intlOptions: Intl.NumberFormatOptions = {};

  if (value === undefined || value === null) {
    return "-";
  }

  if (options?.fixedDecimal) {
    intlOptions.minimumFractionDigits = 2;
    intlOptions.maximumFractionDigits = 2;
  }
  const formatter = new Intl.NumberFormat("sv-SE", intlOptions);

  return formatter.format(value);
}

type FormatMoneyOptions = {
  fixedDecimal?: boolean;
  currency?: string;
};

export function formatMoney(
  value?: number | bigint | null,
  options?: FormatMoneyOptions,
): string {
  const currency = options?.currency ?? "kr";

  return `${value || value === 0 ? formatNumber(value, options) : "-"} ${currency}`.replace(
    " ",
    "\u00a0",
  );
}
